/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCreditNote = /* GraphQL */ `
  mutation CreateCreditNote(
    $input: CreateCreditNoteInput!
    $condition: ModelCreditNoteConditionInput
  ) {
    createCreditNote(input: $input, condition: $condition) {
      id
      credit_note_number
      order_number
      customer_name
      delivery_date
      order_value
      credit_type
      reason
      comments
      at_fault
      status
      approved_by
      approved_at
      requested_at
      brand
      country
      folder
      created_by
      created_at
      updated_by
      updated_at
      line_items {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCreditNote = /* GraphQL */ `
  mutation UpdateCreditNote(
    $input: UpdateCreditNoteInput!
    $condition: ModelCreditNoteConditionInput
  ) {
    updateCreditNote(input: $input, condition: $condition) {
      id
      credit_note_number
      order_number
      customer_name
      delivery_date
      order_value
      credit_type
      reason
      comments
      at_fault
      status
      approved_by
      approved_at
      requested_at
      brand
      country
      folder
      created_by
      created_at
      updated_by
      updated_at
      line_items {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCreditNote = /* GraphQL */ `
  mutation DeleteCreditNote(
    $input: DeleteCreditNoteInput!
    $condition: ModelCreditNoteConditionInput
  ) {
    deleteCreditNote(input: $input, condition: $condition) {
      id
      credit_note_number
      order_number
      customer_name
      delivery_date
      order_value
      credit_type
      reason
      comments
      at_fault
      status
      approved_by
      approved_at
      requested_at
      brand
      country
      folder
      created_by
      created_at
      updated_by
      updated_at
      line_items {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLineItem = /* GraphQL */ `
  mutation CreateLineItem(
    $input: CreateLineItemInput!
    $condition: ModelLineItemConditionInput
  ) {
    createLineItem(input: $input, condition: $condition) {
      id
      creditNoteLine_itemsId
      credit_note {
        id
        credit_note_number
        order_number
        customer_name
        delivery_date
        order_value
        credit_type
        reason
        comments
        at_fault
        status
        approved_by
        approved_at
        requested_at
        brand
        country
        folder
        created_by
        created_at
        updated_by
        updated_at
        createdAt
        updatedAt
        __typename
      }
      sku
      item_name
      use_by_date
      quantity_ordered
      quantity_to_credit
      original_unit_price
      unit_price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLineItem = /* GraphQL */ `
  mutation UpdateLineItem(
    $input: UpdateLineItemInput!
    $condition: ModelLineItemConditionInput
  ) {
    updateLineItem(input: $input, condition: $condition) {
      id
      creditNoteLine_itemsId
      credit_note {
        id
        credit_note_number
        order_number
        customer_name
        delivery_date
        order_value
        credit_type
        reason
        comments
        at_fault
        status
        approved_by
        approved_at
        requested_at
        brand
        country
        folder
        created_by
        created_at
        updated_by
        updated_at
        createdAt
        updatedAt
        __typename
      }
      sku
      item_name
      use_by_date
      quantity_ordered
      quantity_to_credit
      original_unit_price
      unit_price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLineItem = /* GraphQL */ `
  mutation DeleteLineItem(
    $input: DeleteLineItemInput!
    $condition: ModelLineItemConditionInput
  ) {
    deleteLineItem(input: $input, condition: $condition) {
      id
      creditNoteLine_itemsId
      credit_note {
        id
        credit_note_number
        order_number
        customer_name
        delivery_date
        order_value
        credit_type
        reason
        comments
        at_fault
        status
        approved_by
        approved_at
        requested_at
        brand
        country
        folder
        created_by
        created_at
        updated_by
        updated_at
        createdAt
        updatedAt
        __typename
      }
      sku
      item_name
      use_by_date
      quantity_ordered
      quantity_to_credit
      original_unit_price
      unit_price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      order_number
      customer_name
      delivery_date
      order_value
      brand
      brand_country
      line_items {
        id
        sku
        item_name
        quantity
        gross_amount
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      order_number
      customer_name
      delivery_date
      order_value
      brand
      brand_country
      line_items {
        id
        sku
        item_name
        quantity
        gross_amount
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      order_number
      customer_name
      delivery_date
      order_value
      brand
      brand_country
      line_items {
        id
        sku
        item_name
        quantity
        gross_amount
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrderLineItem = /* GraphQL */ `
  mutation CreateOrderLineItem(
    $input: CreateOrderLineItemInput!
    $condition: ModelOrderLineItemConditionInput
  ) {
    createOrderLineItem(input: $input, condition: $condition) {
      id
      sku
      item_name
      quantity
      gross_amount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrderLineItem = /* GraphQL */ `
  mutation UpdateOrderLineItem(
    $input: UpdateOrderLineItemInput!
    $condition: ModelOrderLineItemConditionInput
  ) {
    updateOrderLineItem(input: $input, condition: $condition) {
      id
      sku
      item_name
      quantity
      gross_amount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrderLineItem = /* GraphQL */ `
  mutation DeleteOrderLineItem(
    $input: DeleteOrderLineItemInput!
    $condition: ModelOrderLineItemConditionInput
  ) {
    deleteOrderLineItem(input: $input, condition: $condition) {
      id
      sku
      item_name
      quantity
      gross_amount
      createdAt
      updatedAt
      __typename
    }
  }
`;
